import { createAuthClient } from "better-auth/react"
import { twoFactorClient } from "better-auth/client/plugins"

/** Auth client for the browser. Configured to talk to our better-auth API and includes the 2FA plugin. */
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
  plugins: [twoFactorClient()],
})

export type AuthClient = typeof authClient
